<template>
  <div>
    <h2>SessionsSubpage</h2>
  </div>
</template>

<script>
export default {
  name: "SessionsSubpage",
  data: () => ({
  }),
  computed: {
  },
  methods: {
  },
  components: {
  }
};
</script>

<style>
</style>
